import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    FileUploadDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    webStyle
} from "../../utils";

const stylesheet = StyleSheet.create({
    status: {
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        ...webStyle({
            clipPath: "inset(50%)",
            whiteSpace: "nowrap"
        })
    },
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    helper: {
        alignItems: "center",
        flexDirection: "row"
    },
    stretched: {
        alignSelf: "stretch"
    },
    helperText: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    borders,
    spaces
}: FileUploadDynamicStyleType) => {
    const styles = {
        helper: {
            columnGap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        container: {
            rowGap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        status: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
